import React from "react";
import styles from "./RichText.module.css";

interface RichTextProps {
  data: string;
  className?: string;
}

const RichText: React.FC<RichTextProps> = ({ data, className }) => (
  <div
    className={`${styles.pageDescription} ${className || ""}`}
    dangerouslySetInnerHTML={{ __html: data }}
  />
);

export default RichText;
